import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import { BarCodeScanner } from 'expo-barcode-scanner';
import { FormattedMessage } from 'react-intl';

import styles from './styles';

const QrCodePay = ({ navigation }) => {
    const [hasPermission, setHasPermission] = useState(null);
    const [scanned, setScanned] = useState(false);

    useEffect(() => {
        (async () => {
            const { status } = await BarCodeScanner.requestPermissionsAsync();
            setHasPermission(status === 'granted');
        })();
    }, []);

    const handleBarCodeScanned = ({ type, data }) => {
        setScanned(true);
        navigation.navigate('QrCodeConfirmPay');
    };

    if (hasPermission === null) {
        return <Text><FormattedMessage id='qrCodePay.txtPrecisaAcessoCamera'/></Text>;
    }
    if (hasPermission === false) {
        return <Text><FormattedMessage id='qrCodePay.txtSemAcessoCamera'/></Text>;
    }

    return (
        <View style={styles.container}>
            <MaterialIcons
                name="keyboard-arrow-left"
                size={30}
                color="#fff"
                style={styles.iconBackPage}
                onPress={() => navigation.goBack()}
            />
            
            <Text style={styles.textInfoQrCode}><FormattedMessage id='qrCodePay.txtAponteLeitorQrCode'/></Text>
            <BarCodeScanner
                onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
                style={styles.contentQrCode}
            />
        </View>
    );
}

export default QrCodePay;